import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import useAuth from '../../../hooks/useAuth';
import img from '../../../Assets/login.jpg'
import './AdminLogin.css'



const AdminLogin = () => {
    const [loginData, setLoginData] = useState({});
    const { user, loginUser, authError } = useAuth();

    const location = useLocation();
    const navigate = useNavigate();

    const handleInput = (event) => {
        let newInput = { [event.target.name]: event.target.value };
        setLoginData({ ...loginData, ...newInput });
    };
    const handleLoginSubmit = e => {
        loginUser(loginData.email, loginData.password, location, navigate);
        e.preventDefault();
    }
    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            loginUser(loginData.email, loginData.password, location, navigate);


        }
    }

    return (
        <div className='container'>


            <div className='row' style={{ marginTop: "150px" }}>
                <div className='col-sm-12 col-lg-6'>
                    <img style={{ width: "80%" }} src={img} alt="" />

                </div>
                <div className='col-sm-12 col-lg-6'>
                    <h3>Please Login</h3>

                    <input style={{ width: "60%", marginBottom: "10px" }} onChange={handleInput} type="email" name="email" placeholder="Your Email" id="" /><br />
                    <input style={{ marginBottom: "50px", width: "60%" }} onChange={handleInput} onKeyDown={handleKeyDown} type="password" name="password" placeholder="Password" id="" /> <br />

                    <button type="submit" className="btn btn-secondary" onClick={handleLoginSubmit} >Submit</button> <br /><br />
                    <button type="goBackHome" className="btn btn-secondary " ><a className='link' href="/">Back to Home</a></button>




                    {user?.email && <p> logged in successfully!</p>}
                    {authError && <p>{authError}</p>}





                </div>
            </div>

        </div>
    );
};

export default AdminLogin;